import React from 'react'

import styled from 'styled-components'

import { FiChevronDown } from 'react-icons/fi';
import { NavLink } from 'react-router-dom';

const Dropdown = ({ closeMenu }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  return (
    <StyledDropdown>
        {
            isOpen && (
                <div className="overlay" onClick={() => setIsOpen(false)} />
            )
        }
        <span onClick={() => setIsOpen(!isOpen)}>Products</span>
        <FiChevronDown onClick={() => setIsOpen(!isOpen)} />

        {
            isOpen && (
                <div className="dropdown-menu">
                    <NavigationLink onClick={() => {setIsOpen(!isOpen); closeMenu()}} to="/products/mula-wallet">Mula Wallet</NavigationLink>
                    <NavigationLink onClick={() => {setIsOpen(!isOpen); closeMenu()}} to="/products/commerce">Commerce</NavigationLink>
                    <NavigationLink onClick={() => {setIsOpen(!isOpen); closeMenu()}} to="/products/cassava">Cassava</NavigationLink>
                    <NavigationLink onClick={() => {setIsOpen(!isOpen); closeMenu()}} to="/products/developers">Developers</NavigationLink>
                </div>
            )
        }
    </StyledDropdown>
  )
}

const StyledDropdown = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: auto;
    font-size: ${({ theme }) => theme.fontSizes.h5};
    font-weight: ${({ theme }) => theme.fontWeights.normal};
    color: ${({ theme }) => theme.colors.primary};
    cursor: pointer;
    position: relative;
    z-index: 2;

    .overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        cursor: default;
    }

    span {
        margin-right: .5rem;
    }

    .dropdown-menu {
        position: absolute;
        top: 120%;
        left: 0;
        width: 246px;
        padding: 1rem 1.5rem;
        background: ${({ theme }) => theme.colors.white};
        box-shadow: 0px -11px 142px rgba(198, 198, 198, 0.8);
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        gap: 1rem;
        z-index: 44;
    }
`

const NavigationLink = styled(NavLink)`
  font-size: ${({ theme }) => theme.fontSizes.h5};
  text-decoration: none;
  color: ${({ theme }) => theme.colors.primary};
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  transition: all 0.3s ease-in-out;
  position: relative;

  &:hover, &:focus, &:active, &.active {
    font-weight: ${({ theme }) => theme.fontWeights.bold};
  }
`

export default Dropdown